export const splitParams = (params, predicate) =>
	Object.entries(params).reduce(
		(result, [key, value]) => {
			result[predicate([key, value]) ? 0 : 1][key] = value;
			return result;
		},
		[{}, {}],
	);
